export default __webpack_public_path__ + "static/media/proj1mov.a3dcd670.mp4";